import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import { useState } from "react";
import useColumnDefs from "./columnDefs";
import { RootState } from "../../../../../store/app";

/**
 * Renders listing component for skill categories with action buttons.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.moduleInfo - Information about the module.
 * @param {Function} props.handleViewClick - The function to handle view click.
 * @param {Function} props.handleDeleteClick - The function to handle delete click.
 * @param {Function} props.handleEditClick - The function to handle edit click.
 * @return {JSX.Element} The rendered listing component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
}) => {
  const columnDefs = useColumnDefs();
  const skillCategories = useAppSelector(
    (state: RootState) => state.skillCategories
  );
  const [statusData, setStatusData] = useState<any>();

  /**
   * Renders an ActionRenderer component for the ag grid contains the action buttons.
   */
  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        rowData={skillCategories.rowData}
        onGridReadyWithDispatch={setGrid}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={skillCategories.perPage}
        cacheBlockSize={skillCategories.perPage}
      />
    </>
  );
};

export default Listing;
